import React, { useReducer } from "react";
import axios from "axios";
import CartContext from "./CartContext";
import CartReducer from "./CartReducer";
import {
  USER_CART_LOADING,
  USER_CART_LOADED,
  CART_PROCESSING,
  CART_PROCESSED,
  USER_CART_ERROR,
  RESET_CART,
  INIT_EDIT_CART_ITEM,
} from "../types";
import { env } from "../../env";

const API_HOST = env.REACT_APP_HMW_API_HOST_NAME;
// const API_HOST = "";
const CartState = (props) => {
  const initialState = {
    cart: null,
    error: null,
    loading: false,
    loaded: false,
    selectedCartItem: null,
    cartAction: null,
  };
  const [state, dispatch] = useReducer(CartReducer, initialState);
  //Reset Context State
  const resetCartState = () => {
    dispatch({
      type: RESET_CART,
      payload: { ...initialState },
    });
  };
  //Initialize Cart Edit action
  const initEditCartItem = (cartAction) => {
    dispatch({
      type: INIT_EDIT_CART_ITEM,
      payload: { cartAction },
    });
  };
  //Add Item to the cart
  const addItem = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      // formData.contractid =;
      // formData.rechargevalue=;
      formData.action = "CARD_MANAGEMENT";
      formData.function = "recharge_card";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: CART_PROCESSING,
        });
        const res = await axios.post(
          `${API_HOST}/cart/addRechargeCard`,
          formData,
          config
        );
        console.log("Item Added to Cart ", res);
        dispatch({
          type: CART_PROCESSED,
        });
        resolve(res.data);
      } catch (err) {
        dispatch({
          type: USER_CART_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Add multiple Items to the cart
  const addItems = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      // formData.contractid =;
      // formData.rechargevalue=;
      formData.action = "SPONSER_RECHARGE_MANAGEMENT";
      formData.function = "add_recharge_cards";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: CART_PROCESSING,
        });
        const res = await axios.post(
          `${API_HOST}/recharge/addRechargeCards`,
          formData,
          config
        );
        console.log("Items Added to Cart ", res);
        dispatch({
          type: CART_PROCESSED,
        });
        resolve(res);
      } catch (err) {
        dispatch({
          type: USER_CART_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Add Subscription to the cart
  const addSubscription = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      // formData.contractid =;
      // formData.rechargevalue=;
      formData.action = "SUBSCRIPTION_MANAGEMENT";
      formData.function = "add_subscription";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: CART_PROCESSING,
        });
        const res = await axios.post(
          `${API_HOST}/subscription/addSubscription`,
          formData,
          config
        );
        console.log("Item Added to Cart ", res);
        dispatch({
          type: CART_PROCESSED,
        });
        resolve(res);
      } catch (err) {
        dispatch({
          type: USER_CART_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Add Subscription for RideSponsor to the cart
  const addRSSubscription = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      // formData.contractid =;
      // formData.rechargevalue=;
      formData.action = "COMPANY_CARD_MANAGEMENT";
      formData.function = "add_subscription";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: CART_PROCESSING,
        });
        const res = await axios.post(
          `${API_HOST}/rssubscription/addSubscription`,
          formData,
          config
        );
        console.log("Item Added to Cart ", res);
        dispatch({
          type: CART_PROCESSED,
        });
        resolve(res);
      } catch (err) {
        dispatch({
          type: USER_CART_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Delete Item to the cart
  const deleteItem = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      // formData.orderItemId =;
      formData.action = "CART_MANAGEMENT";
      formData.function = "delete_order_item";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: CART_PROCESSING,
        });
        const res = await axios.post(
          `${API_HOST}/cart/deleteOrderItem`,
          formData,
          config
        );
        console.log("Item deleted from Cart", res);
        dispatch({
          type: CART_PROCESSED,
        });
        resolve(res);
      } catch (err) {
        dispatch({
          type: USER_CART_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Modify Item on the cart
  const modifyItem = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      // formData.contractid =;
      // formData.rechargevalue=;
      // formData.orderItemId =;
      formData.action = "CART_MANAGEMENT";
      formData.function = "edit_order_item";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: CART_PROCESSING,
        });
        const res = await axios.post(
          `${API_HOST}/cart/editOrderItem`,
          formData,
          config
        );
        console.log("Item modified onto the Cart", res);
        dispatch({
          type: CART_PROCESSED,
        });
        resolve(res);
      } catch (err) {
        dispatch({
          type: USER_CART_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Load cart Items
  const loadItems = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "CART_MANAGEMENT";
      formData.function = "cart_items";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: USER_CART_LOADING,
        });
        const res = await axios.post(
          `${API_HOST}/cart/cartItems`,
          formData,
          config
        );
        console.log("Loaded Cart Items", res);
        dispatch({
          type: USER_CART_LOADED,
          payload: res.data.data,
        });
        console.log("Cart Loaded");
        resolve(res.data.data);
      } catch (err) {
        dispatch({
          type: USER_CART_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Add multiple Subscriptions to the cart
  const addSubscriptions = async (formData, token) => {
    // let payload = {};
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      // formData.contractid =;
      // formData.rechargevalue=;
      // payload.employeeSubscriptions = formData;
      formData.action = "SPONSER_SUBSCRIPTION_MANAGEMENT";
      formData.function = "add_subscription";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: CART_PROCESSING,
        });
        const res = await axios.post(
          `${API_HOST}/rssubscription/add`,
          formData,
          config
        );
        console.log("Items Added to Cart ", res);
        dispatch({
          type: CART_PROCESSED,
        });
        resolve(res);
      } catch (err) {
        dispatch({
          type: USER_CART_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Modify Subscription to the cart
  const updateSubscription = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      // formData.contractid =;
      // formData.rechargevalue=;
      formData.action = "SUBSCRIPTION_MANAGEMENT";
      formData.function = "update_subscription";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: CART_PROCESSING,
        });
        const res = await axios.post(
          `${API_HOST}/subscription/updateSubscription`,
          formData,
          config
        );
        console.log("Item Added to Cart ", res);
        dispatch({
          type: CART_PROCESSED,
        });
        resolve(res);
      } catch (err) {
        dispatch({
          type: USER_CART_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Modify Subscription to the cart
  const cancelSubscription = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      // formData.contractid =;
      // formData.rechargevalue=;
      formData.action = "SUBSCRIPTION_MANAGEMENT";
      formData.function = "delete_subscription";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: CART_PROCESSING,
        });
        const res = await axios.post(
          `${API_HOST}/subscription/deleteSubscription`,
          formData,
          config
        );
        console.log("Item Added to Cart ", res);
        dispatch({
          type: CART_PROCESSED,
        });
        resolve(res);
      } catch (err) {
        dispatch({
          type: USER_CART_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Modify Subscription to the cart
  const cancelSubscriptions = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      // formData.contractid =;
      // formData.rechargevalue=;
      formData.action = "SPONSER_SUBSCRIPTION_MANAGEMENT";
      formData.function = "delete_subscription";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: CART_PROCESSING,
        });
        const res = await axios.post(
          `${API_HOST}/rssubscription/delete`,
          formData,
          config
        );
        console.log("Item Added to Cart ", res);
        dispatch({
          type: CART_PROCESSED,
        });
        resolve(res);
      } catch (err) {
        dispatch({
          type: USER_CART_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Modify Subscription Payment method to the cart
  const updatePayment = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      // formData.contractid =;
      // formData.rechargevalue=;
      formData.action = "SUBSCRIPTION_MANAGEMENT";
      formData.function = "update_spa";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: CART_PROCESSING,
        });
        const res = await axios.post(
          `${API_HOST}/subscription/updateSPA`,
          formData,
          config
        );
        console.log("Item Added to Cart ", res);
        dispatch({
          type: CART_PROCESSED,
        });
        resolve(res);
      } catch (err) {
        dispatch({
          type: USER_CART_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Retrieve Subscription Payment method to the cart
  const getPaymentMethod = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      // formData.contractid =;
      // formData.rechargevalue=;
      formData.action = "SUBSCRIPTION_MANAGEMENT";
      formData.function = "get_spa";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: CART_PROCESSING,
        });
        const res = await axios.post(
          `${API_HOST}/subscription/getSPA`,
          formData,
          config
        );
        console.log("Item Added to Cart ", res);
        dispatch({
          type: CART_PROCESSED,
        });
        resolve(res);
      } catch (err) {
        dispatch({
          type: USER_CART_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  return (
    <CartContext.Provider
      value={{
        ...state,
        resetCartState,
        addItem,
        addItems,
        modifyItem,
        deleteItem,
        loadItems,
        addSubscription,
        addRSSubscription,
        addSubscriptions,
        updateSubscription,
        cancelSubscription,
        cancelSubscriptions,
        updatePayment,
        getPaymentMethod,
        initEditCartItem,
      }}
    >
      {props.children}
    </CartContext.Provider>
  );
};

export default CartState;
